export default {
  doCancel () {
    this.$resource.update(this.schedule.id + '/cancel', {})
    .then(() => {
      this.$emit('on-canceled', this.schedule)
      this.$emit('close')
    })
    .catch(() => {
      alert('Falha ao cancelar')
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/cancel/resources/methods.js